<template>
    <Theme type="designer">
        <template v-slot:navigation>

            <ul class="navbar-nav ml-lg-auto mr-3" v-if="hasAnyPermissions(['viewCeremonies', 'manageSongs', 'manageEmailTemplates', 'viewEmailLogs', 'adminCompanies', 'downloadController', 'manageCorporateStyle', 'manageWelcomeSigns'])">
                <li class="nav-item nav-item-spaced d-none d-lg-block" v-if="hasPermission('viewCeremonies')">
                    <router-link class="nav-link" :to="{name: 'ceremonies'}">
                        {{ $t('designer.ceremonies') }}
                    </router-link>
                </li>

                <li class="nav-item nav-item-spaced d-none d-lg-block"></li>

                <!-- Pages menu -->
                <li
                    class="nav-item nav-item-spaced dropdown dropdown-animate"
                    data-toggle="hover"
                    v-if="
                        hasAnyPermissions(['manageSongs', 'manageEmailTemplates', 'viewEmailLogs', 'downloadController', 'manageCorporateStyle']) ||
                        (hasPermission('manageWelcomeSignOverrides') && companySettings?.welcome_signs_count) ||
                        (hasPermission('manageWelcomeSigns') && companySettings?.welcome_signs_count)
                    "
                >
                    <a class="nav-link" href="#" role="button">{{ $t('designer.manage') }}</a>
                    <div class="dropdown-menu dropdown-menu-md p-0">
                        <ul class="list-group list-group-flush">
                            <li v-if="hasPermission('manageWelcomeSignOverrides') && companySettings?.welcome_signs_count">
                                <router-link :to="{name: 'welcomeSignOverrides'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.welcome_sign_overrides') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('manageSongs')">
                                <router-link :to="{name: 'songs'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.music_library') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('manageUsers')">
                                <router-link :to="{name: 'users'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.manage_users') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('manageEmailTemplates')">
                                <router-link :to="{name: 'email_templates'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.email_templates') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('viewEmailLogs')">
                                <router-link :to="{name: 'email_logs'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.email_logs') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('downloadController') && controllerPath && !isLiteVersion && isLocal">
                                <a :href="controllerPath" target="_blank" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.controller') }}</h6>
                                        </div>
                                    </div>
                                </a>
                            </li>

                            <li v-if="hasPermission('manageCorporateStyle') ">
                                <router-link :to="{name: 'corporate_style'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.corporate_style') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('manageWelcomeSigns') && companySettings?.welcome_signs_count">
                                <router-link :to="{name: 'welcomeSigns'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.manage_welcome_signs') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </li>

                <li class="nav-item nav-item-spaced dropdown dropdown-animate" data-toggle="hover" v-if="hasAnyPermissions(['adminCompanies', 'adminUsers', 'adminBlockRenders', 'horizon'])">
                    <a class="nav-link" href="#" role="button">{{ $t('designer.admin') }}</a>
                    <div class="dropdown-menu dropdown-menu-md p-0">
                        <ul class="list-group list-group-flush">
                            <li v-if="hasPermission('adminCompanies')">
                                <router-link :to="{name: 'admin-clients-overview'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.clients') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('adminUsers')">
                                <router-link :to="{name: 'admin-users-overview'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">{{ $t('designer.manage_users') }}</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('adminBlockRenders')">
                                <router-link :to="{name: 'admin-block-renders-overview'}" tag="a" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">Blok renders</h6>
                                        </div>
                                    </div>
                                </router-link>
                            </li>

                            <li v-if="hasPermission('horizon')">
                                <a href="/horizon" target="_blank" class="list-group-item list-group-item-action" role="button">
                                    <div class="d-flex">
                                        <div class="ml-3">
                                            <h6 class="heading mb-0">Horizon</h6>
                                        </div>
                                    </div>
                                </a>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>

            <!-- navigation for the designer without logged in user --- DESIGNER -->

            <ul class="navbar-nav align-items-lg-center d-none d-lg-flex ml-lg-auto">
                <li class="nav-item dropdown dropdown-animate" v-if="ceremony">
                    <div style="position: relative">
                        <h5 class="h6 mb-0">{{ ceremony.name }}</h5>
                        <small style="font-size: 10px; display: block; margin-top: -7px; margin-bottom: -2px;">
                            {{ ceremony.translated_type }}
                        </small>
                        <div style="font-size: 11px; bottom: 5px; margin-bottom: -5px;" v-if="ceremony.date">
                            <template v-if="!ceremony.date_unknown">
                                {{ ceremony.date | moment('LL') }} {{ $t('general.at') }} {{ ceremony.date | moment('LT') }}
                            </template>
                            <template v-else>
                                {{ $t('ceremony.unknown_date') }}
                            </template>
                        </div>
                    </div>
                </li>
            </ul>

            <ul class="navbar-nav align-items-lg-center d-lg-flex ml-lg-auto" v-if="ceremony">
                <li class="nav-item nav-item-spaced mt-3 d-lg-block" v-if="!user"></li>

                <li class="nav-item dropdown dropdown-animate">
                    <button type="button" class="btn btn-company btn-icon btn-sm rounded-pill ml-2 navigation-buttons" @click="previewCeremony">
            <span class="btn-inner--icon">
                <icon name="play" scale="0.8"></icon>
            </span>
                        <span class="btn-inner--text">{{ $t('ceremony.preview') }}</span>
                    </button>
                </li>

                <li class="nav-item dropdown dropdown-animate">
                    <button type="button" class="btn btn-success btn-icon btn-sm rounded-pill ml-2 navigation-buttons"
                            @click="toggleSubmitModal()" :disabled="checkSubmit()">
                        <span class="btn-inner--icon">
                            <icon name="upload" scale="0.8"></icon>
                        </span>

                        <span class="btn-inner--text" v-if="!isLiteVersion">{{ $t('ceremony.submit_to_company', { company: companySettings?.name }) }}</span>
                        <span class="btn-inner--text" v-else>{{ $t('ceremony.submit') }}</span>
                    </button>
                </li>

                <li class="nav-item dropdown dropdown-animate" v-if="!ceremony.is_processing">
                    <a :href="'/api/ceremonies/code/' + ceremony.code  + '/pdf-preview'" target="_blank" type="button"
                       class="btn btn-company btn-icon btn-sm rounded-pill ml-2 navigation-buttons"
                       v-tooltip="$t('ceremony.download_pdf_tooltip', { type: ceremony.translated_type.toLowerCase() })">
                        <span class="btn-inner--icon">
                            <icon name="book" class="mr-0"></icon>
                        </span>
                    </a>
                </li>

                <li class="nav-item dropdown dropdown-animate">
                    <button type="button" class="btn btn-company-yellow btn-icon btn-sm rounded-pill ml-2 navigation-buttons" @click="openHelpModal()" v-tooltip="$t('general.help')">
                        <span class="btn-inner--icon">
                            <icon name="question" scale="1" class="mr-0"></icon>
                        </span>
                    </button>
                </li>
            </ul>

            <uploading-modal v-if="action"
                             :action="action"
                             @accept="action = null"
                             @ignore="ignoreUploading"
            />

            <submit-ceremony @done_loading="show_final_modal=false" :show_final_modal="show_final_modal"></submit-ceremony>

            <modal :show="show_help_modal" :closable="!loading" @close="show_help_modal = false" :custom_modal_class="'modal-lg'">
                <div slot="header">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            {{ companySettings?.name }} {{ $t('ceremony.funeral_script_title') }}
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="show_help_modal = false">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                </div>

                <div slot="body" v-html="manualInfo"></div>

                <div slot="footer">
                    <a :href="manualLink" target="_blank" class="btn btn-dark btn-sm">
                        {{ $t('ceremony.view_manual') }}
                    </a>
                    <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" @click="show_help_modal = false">
                        {{ $t('general.close') }}
                    </button>
                </div>
            </modal>

            <notifications group="default" />

        </template>

        <div class="alert alert-warning" :class="{ 'remove-sides': !embed }" v-if="ceremony && canSync">
            {{ $t('ceremony.last_minute_warning') }}
        </div>

        <div class="alert alert-info" :class="{ 'remove-sides': !embed }" v-if="checkSubmit() && user">
            {{ $t('ceremony.already_submitted_message', { type: ceremony.translated_type.toLowerCase() }) }}
        </div>

        <div :class="{ 'remove-sides': !embed }" class="d-flex align-items-center" v-if="ceremony && ceremony.type !== 'condolence'">
            <div class="progress progress-lg progress-bar-ceremony w-100" style="border-radius: 0; font-size: 13px;">
                <div class="progress-bar" :class="getClassBasedOnPercentage()" role="progressbar" :style="getProgressPercentage()" :aria-valuenow="getCeremonyDuration(ceremony.total_duration)" aria-valuemin="0" :aria-valuemax="getCeremonyDuration(ceremony.duration)">
                    {{ $t('ceremony.estimated_duration_message', {
                    type: ceremony.translated_type.toLowerCase(),
                    duration: getCeremonyDuration(ceremony.total_duration),
                }) }}
                </div>
            </div>

            <button v-if="embed" type="button" class="btn btn-company btn-icon btn-sm rounded-pill ml-4 navigation-buttons" @click="previewCeremony">
                <span class="btn-inner--icon">
                    <icon name="play" scale="0.8"></icon>
                </span>
                <span class="btn-inner--text">{{ $t('ceremony.preview') }}</span>
            </button>
        </div>

        <fullscreen-loading v-if="loading" />

        <div>
            <router-view></router-view>
        </div>
    </Theme>
</template>

<script>

    import { mapGetters, mapState } from 'vuex';
    import Theme from '../../components/Theme';
    import Modal from '../../components/Modal';
    import SubmitCeremony from './SubmitCeremony';
    import FullscreenLoading from '../../components/FullscreenLoading';
    import UploadingModal from './UploadingModal';
    import i18n from '../../utils/locale';

    export default {

        name: 'designer-app',

        components: {
            SubmitCeremony,
            FullscreenLoading,
            Modal,
            Theme,
            UploadingModal,
        },

        props: [
            'locales',
            'current_locale',
        ],

        data() {
            return {
                show_help_modal: false,
                show_final_modal: false,
                action: null,
            };
        },

        methods: {
            ignoreUploading() {
                if (!this.action) {
                    return;
                }

                this[this.action](true);
            },

            toggleSubmitModal(force = false) {
                if (this.isUploading) {
                    this.action = 'toggleSubmitModal';
                }

                if (this.isUploading && !force) {
                    return;
                }

                this.show_final_modal = true;
            },

            openHelpModal() {
                this.show_help_modal = true;
            },

            previewCeremony() {
                this.$store.commit('showCeremonyPreview', this.ceremony);
            },
            getCeremonyDuration(seconds) {
                return parseFloat(seconds / 60).toFixed(0);
            },


            getPercentage() {
                return this.ceremony.total_duration / this.ceremony.duration * 100;
            },

            getProgressPercentage() {
                return `width:${this.getPercentage()}%`;
            },

            getClassBasedOnPercentage() {
                const percentage = this.ceremony.total_duration / this.ceremony.duration * 100;

                if (percentage > 100) {
                    return 'bg-danger';
                }

                return 'bg-primary';
            },

            checkSubmit() {
                if (!this.ceremony) {
                    return false;
                }

                return (this.ceremony.state_id === 2);
            },

        },

        computed: {
            controllerPath() {
                return window.CONTROLLER_PATH;
            },
            manualLink() {
                return this.companySettings?.manual || 'https://302uitvaart.nl/assets/draaiboek-handleiding.pdf';
            },
            manualInfo() {
                return this.companySettings?.manual_info;
            },
            canSync() {
                return Boolean(window.SYNC_FROM);
            },
            isLiteVersion() {
                return !!window.IS_LITE_VERSION;
            },
            isLocal() {
                return !!window.IS_LOCAL;
            },
            embed() {
                return window.location.search.includes('embed=true');
            },
            ...mapState({
                loading: state => state.loading,
                user: state => state.user,
                ceremony: state => state.ceremony,
                isUploading: state => state.isUploading,
                token: state => state.token,
                companySettings: state => state.companySettings,
            }),

            ...mapGetters([
                'hasPermission',
                'hasAnyPermissions',
            ])
        },

        created() {
            this.$store.dispatch('setLocales', this.locales);
            this.$store.dispatch('start', this.current_locale);

            const self = this;
            window.addEventListener('beforeunload', function(event) {
                if (!self.isUploading) {
                    return;
                }

                self.action = 'tab_close';

                const confirmationMessage = i18n.t('ceremony.upload_incomplete_warning');

                (event || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage;                            //Webkit, Safari, Chrome
            });
        },
    };

</script>
<style lang="scss" scoped>
    .progress-bar-ceremony {
        .progress-bar {
            overflow: visible;
            text-shadow: 1px 1px 4px black;
        }
    }

    .remove-sides {
        margin-bottom: 0;
        margin-right: -15px;
        margin-left: -15px;
        border-radius: 0;
    }

    @media(max-width: 992px) {
        .navigation-buttons {
            width: 100%;
            margin-left: 0 !important;
            margin-bottom: 5px;
        }
    }
</style>
